import { PrivacyWord } from './privacyWord'
export class PrivacyWordConstructor implements PrivacyWord {
  privacyWordId = ''
  tenantId = ''
  targetWord = ''
  alternateWord = ''
}